(() => {
  const quote = value => String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  function categoryQuery(term, category) {
    if (!category) return term.trim();
    const tokens = term.match(/[\p{L}\p{N}]+(?:[-'][\p{L}\p{N}]+)*/gu) || [];
    const words = tokens.map(token => `${token}*`).join(' AND ');
    return `product_type:"${quote(category)}"${words ? ` AND (${words})` : ''}`;
  }
  if (typeof module !== 'undefined') module.exports = {categoryQuery};
  if (typeof customElements === 'undefined' || customElements.get('catalog-search')) return;
  customElements.define('catalog-search', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      const events = {signal: this.listeners.signal};
      this.input = this.querySelector('input[type="search"]');
      this.category = this.querySelector('[data-category]');
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.catalog-search__panel');
      this.initial = this.querySelector('[data-initial]');
      this.results = this.querySelector('[data-results]');
      this.message = this.querySelector('[data-message]');
      this.all = this.querySelector('[data-all]');
      this.version = 0;
      const restored = new URL(location.href).searchParams;
      if ([...this.category.options].some(option=>option.value===restored.get('catalog_category'))) {
        this.category.value=restored.get('catalog_category')||'';
        this.input.value=restored.get('catalog_query')||'';
      }
      this.input.addEventListener('focus', () => this.refresh(), events);
      this.input.addEventListener('input', () => this.refresh(), events);
      this.category.addEventListener('change', () => {this.refresh();this.input.focus();}, events);
      this.category.addEventListener('pointerdown', () => this.close(), events);
      this.form.addEventListener('submit', event => {
        if (!this.input.value.trim() && !this.category.value) {event.preventDefault();this.input.focus();this.refresh();return;}
        event.preventDefault();
        window.location.assign(this.url().href);
      }, events);
      document.addEventListener('pointerdown', event => {if (!this.contains(event.target)) this.close();}, events);
      this.addEventListener('focusout', () => setTimeout(() => {if (!this.contains(document.activeElement)) this.close();}, 0), events);
      this.addEventListener('keydown', event => {
        if (event.target === this.category) return;
        if (event.key === 'Escape') {this.input.focus({preventScroll:true});this.close();event.preventDefault();return;}
        if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
        event.preventDefault();this.open();
        const items = [this.input,...[...this.panel.querySelectorAll('a')].filter(a=>a.getClientRects().length)];
        const index = items.indexOf(document.activeElement);
        items[(index+(event.key==='ArrowDown'?1:-1)+items.length)%items.length].focus({preventScroll:true});
      }, events);
      const reposition = () => {if (!this.panel.hidden) this.position();};
      window.addEventListener('resize', reposition, events);
      window.addEventListener('scroll', reposition, {...events,passive:true});
      window.visualViewport?.addEventListener('resize', reposition, events);
      window.visualViewport?.addEventListener('scroll', reposition, events);
      this.updateLink();
    }
    url() {
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('q', categoryQuery(this.input.value, this.category.value));
      url.searchParams.set('options[prefix]', 'last');
      if (this.category.value) {url.searchParams.set('type','product');url.searchParams.set('catalog_category',this.category.value);url.searchParams.set('catalog_query',this.input.value.trim());}
      return url;
    }
    updateLink() {this.all.href=this.url().href;}
    refresh() {
      clearTimeout(this.timer);this.request?.abort();const version=++this.version;
      this.updateLink();this.open();
      const hasSearch = !!(this.input.value.trim() || this.category.value);
      this.initial.hidden=hasSearch;this.results.hidden=true;this.message.textContent='';
      if (!hasSearch) return;
      this.message.textContent='Loading results...';
      this.timer=setTimeout(()=>this.search(version),220);
    }
    position() {
      const rect=this.form.getBoundingClientRect();const viewport=window.visualViewport;
      const width=document.documentElement.clientWidth;
      const bottom=(viewport?.height||window.innerHeight)+(viewport?.offsetTop||0);
      if (rect.bottom<0 || rect.top>bottom) {this.close();return;}
      const panelWidth=width<750?width-24:Math.min(Math.max(rect.width,720),width-32);
      const left=Math.max(12,Math.min(rect.left,width-panelWidth-12));
      const top=rect.bottom+6;
      this.panel.style.setProperty('--catalog-left',`${left}px`);
      this.panel.style.setProperty('--catalog-top',`${top}px`);
      this.panel.style.setProperty('--catalog-width',`${panelWidth}px`);
      this.panel.style.setProperty('--catalog-height',`${Math.max(100,Math.min(620,bottom-top-12))}px`);
      const actual=this.panel.getBoundingClientRect();
      if (actual.width) {
        this.panel.style.setProperty('--catalog-left',`${left+(left-actual.left)}px`);
        this.panel.style.setProperty('--catalog-top',`${top+(top-actual.top)}px`);
      }
    }
    open() {this.panel.hidden=false;this.position();this.input.setAttribute('aria-expanded','true');}
    close() {++this.version;clearTimeout(this.timer);this.request?.abort();this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');}
    async search(version) {
      const controller=new AbortController();this.request=controller;
      const timeout=setTimeout(()=>controller.abort('timeout'),10000);
      try {
        let url;
        if (this.category.value) {url=this.url();url.searchParams.set('section_id','catalog-search-results');}
        else {url=new URL(this.dataset.predictiveUrl,location.origin);url.search=new URLSearchParams({q:this.input.value.trim(),'resources[type]':'product,collection,article','resources[limit]':'4','resources[limit_scope]':'each',section_id:'catalog-search-results'});}
        const response=await fetch(url,{signal:controller.signal,credentials:'same-origin'});
        if (!response.ok) throw Error(`Search HTTP ${response.status}`);
        const documentResult=new DOMParser().parseFromString(await response.text(),'text/html');
        const section=documentResult.querySelector('#shopify-section-catalog-search-results');
        if (!section) throw Error('Search section missing');
        if (version!==this.version || this.panel.hidden) return;
        const cards=[...section.querySelectorAll('[data-product-type]')];
        if (this.category.value && cards.some(card=>card.dataset.productType!==this.category.value)) throw Error('Category filtering mismatch');
        this.results.innerHTML=section.innerHTML;this.results.hidden=false;
        this.message.textContent=cards.length?`${cards.length} products shown`:'';this.position();
      } catch(error) {
        if (version!==this.version) return;
        if (error.name==='AbortError' && controller.signal.reason!=='timeout') return;
        this.results.hidden=true;this.message.textContent='Search suggestions unavailable. View all results';
      } finally {clearTimeout(timeout);}
    }
    disconnectedCallback() {this.listeners?.abort();this.listeners=null;this.request?.abort();clearTimeout(this.timer);++this.version;}
  });
  document.addEventListener('DOMContentLoaded',()=>{
    const params=new URL(location.href).searchParams;
    const category=params.get('catalog_category');
    if (!category || !document.querySelector('catalog-search option') || ![...document.querySelectorAll('catalog-search option')].some(option=>option.value===category)) return;
    const term=params.get('catalog_query')||'';
    for (const input of document.querySelectorAll('input[type="search"][name="q"]')) {
      if (input.closest('catalog-search')) continue;
      input.value=term;
      input.form?.addEventListener('submit',()=>{input.value=categoryQuery(input.value,category);});
    }
    for (const heading of document.querySelectorAll('main h1, main h2')) {
      if (heading.textContent.includes(params.get('q'))) heading.textContent=heading.textContent.replace(params.get('q'),term||category);
    }
  });
})();
